import React, { useCallback, useState, useRef } from 'react'

import { SingleLineChart } from 'nswidgets/src/components/line/line'
import { Tooltip, TOOLTIP_TYPE } from 'nswidgets/src/common/tooltip/tooltip'
import { TooltipContextProvider } from 'nswidgets/src/common/tooltip/tooltip.context'
import { useSideBySideChartContext } from '../../contexts/side-by-side.context'

export const LineBlockChart = function (props = {}) {
  const [tooltipCoordinates, setTooltipCoordinates] = useState()
  const currentHoverRef = useRef()
  const sideBySideChartContext = useSideBySideChartContext()

  const currentHover = sideBySideChartContext && sideBySideChartContext.chartMirrorData && sideBySideChartContext.chartMirrorData.currentHover

  const onPointUpdate = useCallback((coordinates) => {
    setTooltipCoordinates(coordinates)
  })

  const onHover = useCallback((currentHover) => {
    currentHoverRef.current = currentHover
    if (sideBySideChartContext) {
      sideBySideChartContext.setChartMirrorDataValue('currentHover', currentHover)
    }
  })

  return (
    <TooltipContextProvider>
      <SingleLineChart
        {...props}
        onHover={onHover}
        onPointUpdate={onPointUpdate}
        currentHover={currentHover}
      />
      <Tooltip
        type={TOOLTIP_TYPE.LIST}
        tooltipCoordinates={currentHover && currentHoverRef.current !== currentHover ? tooltipCoordinates : undefined}
      />
    </TooltipContextProvider>
  )
}
